import { Avatar, type AvatarProps } from '@frontend/legacy-components';

export const CustomAvatar = (props: AvatarProps) => (
  <Avatar alignSelf="center" marginY="auto" size="xs" {...props} />
);
